import { lazy } from 'react';
 
export const routes = [
  {
        path: "/subscriptions",
        exact: true,
        component: lazy(() => import("./components/Subscriptions")),
        name: "Subscriptions"
    },
    {
        path: "/subscriptions/subscription",
        exact: true,
        component: lazy(() => import("./components/SingleSubscription")),
        name: "SingleSubscription"
    }
];
